
import Profile from '@/views/profile/Profile'
export default [
    {
        path: '/dashboard/profile/:userId',
        name: 'profile',
        component: Profile,
        meta: { 
            auth: true,
            logging: true,
            path: '/dashboard/profile',
            pageName: '명함보기',
        }
    },
]